import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormBuilder,FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { IndustryTypeService } from 'src/app/shared/services/industry-type-services/industry-type.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-create-contact',
  templateUrl: './create-contact.component.html',
  styleUrls: ['./create-contact.component.css']
})
export class CreateContactComponent {
  form: FormGroup = new FormGroup({
    userType: new FormControl(''),
    salutation: new FormControl(''),
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    jobTitle: new FormControl(''),
    department:new FormControl(''),
    accountName: new FormControl(''),
    primaryAddressStreet: new FormControl(''),
    primaryAddressPostalcode: new FormControl(''),
    primaryAddressCity:new FormControl(''),
    primaryAddressState: new FormControl(''),
    primaryAddressCountry: new FormControl(''),
    officePhone: new FormControl(''),
    mobile: new FormControl(''),
    fax: new FormControl(''),
    website: new FormControl(''),
    altAddressStreet: new FormControl(''),
    altAddressPostalcode: new FormControl(''),
    altAddressCity: new FormControl(''),
    altAddressState: new FormControl(''),
    altAddressCountry: new FormControl(''),
    email: new FormControl(''),
    description: new FormControl(''),
    assignedTo: new FormControl(''),
  });
  submitted = false;

  currentDate = new Date();
  
  cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
  leadFields = [
    { name: 'salutation', label: 'Salutation', type: 'select', required: true },
    { name: 'firstName', label: 'First Name', required: true },
    { name: 'lastName', label: 'Last Name', required: true },
    { name: 'jobTitle', label: 'Job Title' },
    { name: 'department', label: 'Department' },
    { name: 'accountName', label: 'Account Name' },
    { name: 'primaryAddressStreet', label: 'Primary Address Street' },
    { name: 'primaryAddressPostalcode', label: 'Primary Address Postal Code' },
    { name: 'primaryAddressCity', label: 'Primary Address City' },
    { name: 'primaryAddressState', label: 'Primary Address State' },
    { name: 'primaryAddressCountry', label: 'Primary Address Country' },
    { name: 'email', label: 'Email', required: true },
    { name: 'description', label: 'Description', type: 'textarea' },
  ];
  
  contactFields = [
    { name: 'officePhone', label: 'Office Phone' },
    { name: 'mobile', label: 'Mobile' },
    { name: 'fax', label: 'Fax' },
    { name: 'website', label: 'Website' },
    { name: 'altAddressStreet', label: 'Alt Address Street' },
    { name: 'altAddressPostalcode', label: 'Alt Address Postal Code' },
    { name: 'altAddressCity', label: 'Alt Address City' },
    { name: 'altAddressState', label: 'Alt Address State' },
    { name: 'altAddressCountry', label: 'Alt Address Country' },
  ];
  constructor(
    private formBuilder: FormBuilder,
    private readonly userAuthService: UserService,
    private router: Router,
    private readonly toastrMsgService: ToastrMsgService,
    
    private readonly industryTypeService: IndustryTypeService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group(
      {
        salutation: ['Mr'],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        jobTitle: [''],
        department: [''],
        accountName: [''],
  
        primaryAddressStreet: [''],
        primaryAddressPostalcode: [''],
        primaryAddressCity: [''],
        primaryAddressState: [''],
        primaryAddressCountry: [''],
  
        officePhone: [''],
        mobile: [''],
        fax: [''],
        website: [''],
  
        altAddressStreet: [''],
        altAddressPostalcode: [''],
        altAddressCity: [''],
        altAddressState: [''],
        altAddressCountry: [''],
  
        email: ['', [Validators.required, Validators.email]],
        description: [''],
        assignedTo: ['admin']
      },
      
    );
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }


  onSubmit1(): void {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    console.log(JSON.stringify(this.form.value, null, 2));
  }

  onReset(): void {
    this.submitted = false;
    this.form.reset();
  }

}

